import React from 'react';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';

type BeaconSubtitleContainerProps = {
  children: React.ReactNode;
  wrapperStyle?: React.CSSProperties;
};

/**
 * Container for the subtitles used in certain Beacon Pro charts
 */
export const BeaconSubtitleContainer = ({ children, wrapperStyle }: BeaconSubtitleContainerProps) => {
  return (
    <Flex marginTop="8px" marginBottom="32px" sx={{ ...wrapperStyle }}>
      {children}
    </Flex>
  );
};
